import type {YearValueEditorLocalizations} from './types';


/**
 * @ngdoc constant
 * @name YEAR_VALUE_EDITOR_DEFAULT_LOCALIZATIONS
 * @module portaro.value-editors.year
 *
 * @description
 * ```
 * {
 *      description: ''
 * }
 * ```
 */
export const YEAR_VALUE_EDITOR_DEFAULT_LOCALIZATIONS = Object.freeze<YearValueEditorLocalizations>({
    description: ''
});